import $ from 'jquery';

export default function showFlash(type, message) {
  const $container = $('.flash-messages');
  if ($container.length === 0) {
    $container = $('<div class=".flash-messages"></div>');
    $('body').prepend($container);
  }

  const closeSymbol = '×';
  const $flash = $('<div class="alert">').addClass('alert-' + type)

  $flash.append('<button class="close" type="button" data-dismiss="alert">').text(closeSymbol);
  $flash.append('<div id="flash_alert">').text(message);
  $container.append($flash);

  $flash.slideDown(500).delay(5000).slideUp(500, function () {
    $(this).remove();
  });
}

$(function () {
  $('.alert button.close').click(function () {
    $(this).closest('.alert').slideUp(500, function () {
      $(this).remove();
    });
  });

  $('.alert-success')
    .not('.stay-open')
    .delay(5000)
    .slideUp(300, function () {
      $(this).alert('close');
    });
});
